export const handleWithoutPropagating =
  (handler?: (e: React.MouseEvent) => void) => (e: React.MouseEvent) => {
    e.stopPropagation()
    if (handler) {
      handler(e)
    }
  }
